import * as React from 'react';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { space } from 'styled-system';

const SVG = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M7.5 26a5.5 5.5 0 100-11 5.5 5.5 0 000 11z" fill="#d5ff4f" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.382 7.9H8a.9.9 0 010-1.8h4a.9.9 0 010 1.8h-.69l1.231 3.2h7.622V8c0-.034.002-.067.005-.1H20a.9.9 0 110-1.8h4.106a1.844 1.844 0 110 3.688.9.9 0 110-1.8.044.044 0 100-.088h-2.149a.893.893 0 01.006.1v2.795l1.546 4.294a5.5 5.5 0 11-1.694.61l-.779-2.163-5.063 7.364H6.044l4.713-9.426L9.382 7.9zm3.851 5h6.056l-3.883 5.648-2.173-5.648zm.457 6.2l-2.058-5.35-2.676 5.35h4.734zm10.81-2.3c-.125 0-.248.006-.369.018l1.216 3.377a.9.9 0 01-1.694.61l-1.215-3.377A3.7 3.7 0 1024.5 16.8z"
      fill="#000"
    />
  </svg>
);

const SIZE = 32;
const CAN_SET_COLOR = false;
const SvgBike32Color = styled(SVG)`
  min-height: ${SIZE}px;
  min-width: ${SIZE}px;
  max-height: ${SIZE}px;
  max-width: ${SIZE}px;
  cursor: ${(p) => (p.$pointer || p.onClick ? 'pointer' : 'default')};
  ${(p) =>
    CAN_SET_COLOR &&
    css`
      path {
        fill: ${themeGet(`colors.${p.color}`, p.color)};
      }
    `}
  ${space}
`;
export default SvgBike32Color;
